module.exports = __webpack_public_path__ + "img/Elecocite_80X30.3fd272ca.png";